import { Component, Injector, Input, OnInit } from '@angular/core';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { BillingService } from '../../billing.service';
import { BillingCentralListData } from '../billing-central-list-data';
import { ItemsListContainerBase } from '@fi-app/components/items-list-container-base';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import { CentralBillingUnitModuleModel } from '../central-billing-unit-module.model';
import { IBillingModuleModel } from '@fi-app/billing/billing-header/billing-header.component';

@Component({
    selector: 'fi-billing-central-list',
    template: ` <fi-items-list [settings]="ListData"></fi-items-list>`,
    styleUrls: ['./billing-central-list.component.scss'],
    standalone: false,
})
export class BillingCentralListComponent
    extends ItemsListContainerBase<ListData<CentralBillingUnitModuleModel>>
    implements OnInit
{
    @Input() billingModuleModel: IBillingModuleModel;

    constructor(
        private fiLoadingService: LoadingService,
        private billingService: BillingService,
        private injector: Injector,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(() => new BillingCentralListData(this.injector), {
            noLocalSearch: true,
            showDelete: false,
        });

        setTimeout(() => (this.billingModuleModel.ListData = this.ListData));
    }

    protected LoadItems(): Promise<void> {
        return this.fiLoadingService.trackPromise(
            this.billingService.GetCentralBillingModules().then((items) => {
                this.ListData.appendData(items);
            }),
        );
    }
}
